"use client";

import type { SupWeb3WithdrawSingleVault, SupWithdrawableBalance, SupWithdrawableToken } from "@/types";
import React, { Dispatch, SetStateAction } from "react";

import { SupText, SupIconSlider, SupIconInput } from "@repo/core-ui";

import Web3WithdrawAmountInput from "@/components/Web3/Withdraw/Amount/Input";
import Web3WithdrawAmountSlider from "@/components/Web3/Withdraw/Amount/Slider";

export interface Web3WithdrawAmountProps {
  singleVault: SupWeb3WithdrawSingleVault;
  selectedBalance: SupWithdrawableToken | SupWithdrawableBalance;
  vaultList: SupWeb3WithdrawSingleVault[];
  setVaultList: Dispatch<SetStateAction<SupWeb3WithdrawSingleVault[]>>;
}

export default function Web3WithdrawAmountWrapper(props: Web3WithdrawAmountProps) {
  const [inputMode, setInputMode] = React.useState<"slider" | "input">("slider");
  const handleModeSwitch = () => setInputMode(inputMode === "input" ? "slider" : "input");

  return (
    <div className="inline-flex w-full flex-col items-start justify-start gap-1">
      <div className="flex h-5 flex-col items-start justify-start gap-1 self-stretch">
        <div className="inline-flex h-5 items-center justify-between self-stretch">
          <SupText variant="caption">WITHDRAWAL AMOUNT</SupText>
          <button onClick={handleModeSwitch} className="btn-icon cart-btn group ml-4 flex h-5 w-5 justify-end">
            <span className="sr-only">Switch mode</span>
            {inputMode === "input" ? <SupIconSlider className="h-5 w-5" /> : <SupIconInput className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {inputMode === "input" ? <Web3WithdrawAmountInput {...props} /> : <Web3WithdrawAmountSlider {...props} />}
    </div>
  );
}
